import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <React.Fragment>
    <path fillOpacity=".3" d="M2 22h20V2z" />
    <path d="M14 10L2 22h12z" />
  </React.Fragment>,
  'SignalCellular2Bar',
);
